import { combineReducers } from 'redux'
import quiz from 'redux/quiz/slice'

const rootReducer = combineReducers({ quiz })

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
